import o from"styled-components";import{theme as i}from"../../../../theme.js";const r=o.div`
  position: relative;
  background-color: ${i.colors.gray[100]};
  border-radius: ${i.spacing}px;
  margin-top: ${i.spacing*4}px;
`,e=o.div`
  position: absolute;
  top: 16px;
  left: 16px;
  width: calc(100% - 32px);
  display: flex;
  align-items: center;
  justify-content: space-between;
`,n=o.button`
  border: none;
  font-size: 14px;
  font-weight: 700;
  display: grid;
  align-items: center;
  height: 40px;
  background-color: ${i.colors.gray[50]};
  cursor: pointer;
  transition: all .2s ease-in-out;
  &.iconWithText {
    grid-template-columns: 20px max-content;
    grid-column-gap: ${i.spacing*2}px;
    padding: 0 ${i.spacing*3}px;
    border-radius: ${i.radius}px;
  }
  &.icon {
    grid-template-columns: 40px;
    justify-items: center;
    justify-content: center;
    width: 40px;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
  }
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${i.colors.gray[900]};
    }
  }
  &:hover {
    background-color: ${i.colors.gray[200]};
  }
`,a=o.div`
  max-height: 250px;
  > img {
    display: block;
    margin: auto;
    width: 100%;
    max-height: 250px;
    object-fit: contain;
  }
`,p=o.div`
  padding: ${i.spacing*4}px;
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*2}px;
  margin-top: ${({pictureExists:t})=>t?"0":i.spacing*14}px;
`,s=o.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  word-break: break-all;
  color: ${i.colors.gray[900]};
`,c=o.span`
  display: block;
  font-size: 12px;
  word-break: break-all;
  color: ${i.colors.gray[600]};
`;export{n as Button,e as ButtonsContainer,r as Container,p as DetailsContainer,a as PictureContainer,s as Title,c as Url};
